function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";

const Star = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  style: {
    width: size,
    height: size
  },
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  role: title ? 'img' : 'presentation'
}), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
  fill: color,
  d: "M12.77 15.945l-.774-.468-.775.468-3.137 1.893.833-3.568.205-.882-.684-.593-2.773-2.402 3.648-.309.9-.077.354-.832 1.429-3.372 1.429 3.372.353.832.9.077 3.649.309-2.773 2.402-.685.593.206.882.832 3.568-3.136-1.893zm8.467-6.088c.419-.363.309-.696-.241-.743l-6.19-.525-1.996-4.708-.051-.121-.372-.879c-.216-.509-.567-.507-.782 0l-2.42 5.708-6.19.525c-.552.047-.658.381-.24.743l4.7 4.072-1.168 5.012-.026.111-.217.93c-.126.54.159.744.63.459l5.322-3.212 4.387 2.648.035.021.899.543c.474.286.756.078.63-.459l-.242-1.04-.005-.022-1.164-4.991 4.7-4.072z"
}, " "));

Star.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default Star;